module.exports = __webpack_public_path__ + "static/premium_tradycyjne_zew-ce5b7928bd5b156f92a060b23ca034fe.png";